import type { MoneyProto } from "./types";

export const formatPrice = (amount?: MoneyProto): string => {
  if (!amount) return "—";
  const currency = amount.currencyCode || "USD";
  const nanos = amount.nanos ?? 0;
  const value = Number(amount.units || "0") + nanos / 1_000_000_000;
  if (value === 0) return "";
  const hasFractionalDollars = Math.round(Math.abs(nanos) / 10_000_000) > 0;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: hasFractionalDollars ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(value);
};
